var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.appIsReady)?_c('div',{staticClass:"main-wrapper container"},[_c('router-view',{staticClass:"view-wrapper"})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }